const DOMAIN = /([a-zA-Z0-9-]+?\.[a-zA-Z0-9-]+?)/g;
export { DOMAIN };
